import { UAParser } from 'ua-parser-js'
import { computed } from 'vue'

export function useBrowserInfo() {
  const parser = new UAParser()
  const result = parser.getResult()
  const browserInfo = computed(() => {
    const otherInfo = {
      os: result.os.name || 'Unknown OS',
      osVersion: result.os.version || 'Unknown Version',
      screenSize: `${window.screen.width}x${window.screen.height}`,
      screenDpi: `${window.devicePixelRatio * 96}`,
      browserLanguage: navigator.language,
      browserName: result.browser.name || 'Unknown Browser',
      browserVersion: result.browser.version || 'Unknown Version',
      userAgent: navigator.userAgent,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      url: window.location.href,
    }

    return { otherInfo }
  })

  return { browserInfo }
}
